<template>
  <div class="rc-qr-scan">
    <div class="rc-container">
      <div class="code-container">
        <div class="code">
          <div class="rc-title">
            <h2
              v-html="
                $t('qr-scan-receptionist-page.title', {
                  split: '<br>'
                })
              "
            ></h2>
          </div>
          <br />
          <div
            class="rc-notify"
            style="width: 100%"
            v-html="
              $t(
                'qr-scan-receptionist-page.description',
                { split: '/' },
                { br: '<br>' }
              )
            "
          ></div>
          <div class="code-info">
            <div class="qr-code">
              <qrcode-scan
                :type="QRSCAN_RECEPTION_CHECKIN_ACTION"
                :formatOfData="CHECKIN_RECEPTION_DATA_FORMAT"
              ></qrcode-scan>
            </div>
            <div class="widget-button py-5 text-center">
              <router-link tag="button" :to="pathHome + '/top'">
                <v-btn depressed class="btn-back" outlined color="#e8320e">{{
                  $t('scan-success-page.btn-back', { split: '/' })
                }}</v-btn>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  QRSCAN_RECEPTION_CHECKIN_ACTION,
  CHECKIN_RECEPTION_DATA_FORMAT
} from '@/common/constants';
import QrScan from '@/components/QRCode/QRCodeScan.vue';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'Receptionist-QrScan',

  components: {
    'qrcode-scan': QrScan
  },
  data: () => ({
    QRSCAN_RECEPTION_CHECKIN_ACTION,
    CHECKIN_RECEPTION_DATA_FORMAT
  }),

  validations: {
    entryCode: {
      required
    }
  },

  watch: {
    checkInData: function (val, oldVal) {
      if (val !== oldVal) {
        this.$router.push({ name: 'scan-success', query: { type: 'qr-scan' } });
      }
    },
    '$route.name': function () {
      this.$store.dispatch('clearCheckInData');
    }
  },

  methods: {},

  computed: {
    ...mapGetters({
      checkInData: 'getCheckInData'
    }),

    valueQrCode: function () {
      const value = {
        entry_no: 10,
        contract_id: '1902',
        event_code: 'Jobfair203'
      };

      return JSON.stringify(value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';
@import '@/style/devices.scss';
.rc-qr-scan {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .rc-container {
    width: 80vw;
    margin-top: 50px;

    .rc-title {
      color: #e8320d;
      font-size: 14px;
      text-align: center;
    }
    .rc-notify {
      color: #e8320d;
      font-size: 14px;
      text-align: center;
      margin-bottom: 20px;
    }

    .code-container {
      background: $secondary_blue;
      padding: 24px 0;
      display: flex;
      justify-content: center;

      .code {
        background: #fff;
        border-radius: 10px;
        border: 1px dashed $bold_blue;
        padding: 34px 60px;
        position: relative;
        z-index: 0;
        width: 140% !important;
        max-width: 550px;

        h3 {
          padding-bottom: 22px;
          border-bottom: 1px dashed $bold_blue;
        }

        .code-info {
          display: flex;
          align-items: center;
          .qr-code {
            margin-top: 30px;
            margin-bottom: 30px;
            position: relative;

            .error-tip {
              position: absolute;
              top: -34px;
              left: calc(100% / 3 - 30px);
              width: auto;
              min-height: 1.1rem;
              font-size: 11px;
              padding: 5px;

              font-weight: bold;
              background: #f75636;
              border-radius: 4px;
              color: #fff;

              &::after {
                display: block;
                content: '';
                width: 0;
                height: 0;
                position: absolute;
                bottom: -18px;
                left: 12px;
                border: 18px solid transparent;
                border-top: 0px solid #f75636;
                border-left: 12px solid #f75636;
              }
            }
          }

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .btn-checkin {
            margin-top: 30px;
            width: 350px;
            color: #fff;
          }
          .orderCode {
            color: #fff;
            width: 85%;
            height: 70px;
            font-weight: 900;
            font-size: 40px;
          }

          .title {
            font-weight: 500;
            font-size: 14px !important;
            margin-top: 40px;
            text-align: center;
          }

          .qr-box {
            overflow: hidden;
            background: #fff;
            box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            width: 50%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

@include tablet {
  .rc-qr-scan {
    .code-container {
      margin-top: 50px;
    }
    .rc-container {
      margin-top: 60px !important;
    }
  }
}

@include mobile {
  .rc-qr-scan {
    .rc-container {
      width: 100vw;
      .rc-title {
        padding: 0 10px;
        h2 {
          font-size: 13px !important;
        }
        margin-top: 25px !important;
      }
      .rc-notify {
        padding: 0 10px;
        font-size: 13px;
      }

      .code-container {
        margin-top: 25px !important;
        padding: 15px 15px !important;
        // height: calc(100vh - 50px);
        .code-info {
          .qr-code {
            width: 250px !important;
            margin-top: 30px;
          }
          .v-btn {
            width: 250px !important;
            color: #fff;
            max-width: 80vw !important;
          }
        }
        .code {
          padding: unset !important;
        }
      }
    }
  }
}
</style>
